<div class="login-container">
  <div class="login-card">
    <div class="mode-switch">
      <button type="button" [class.active]="mode === 'login'" (click)="setMode('login')">Accedi</button>
      <button type="button" [class.active]="mode === 'register-company'" (click)="setMode('register-company')">Registra azienda</button>
    </div>

    <div class="login-header">
      <h2>{{ mode === 'login' ? 'Bentornato' : 'Crea il tuo account azienda' }}</h2>
      <p>{{ mode === 'login'
        ? 'Accedi al tuo workspace o a quello cliente gia selezionato.'
        : 'L azienda crea il workspace principale e puo entrare in ogni workspace cliente senza rifare il login.' }}</p>
    </div>

    <form (ngSubmit)="onSubmit()">
      <div class="form-group" *ngIf="mode === 'register-company'">
        <label for="name">Nome azienda</label>
        <input type="text" id="name" [(ngModel)]="name" name="name" placeholder="Inserisci il nome azienda"
          required>
      </div>

      <div class="form-group" *ngIf="mode === 'register-company'">
        <label for="email">Email</label>
        <input type="email" id="email" [(ngModel)]="email" name="email" placeholder="Inserisci email aziendale"
          required>
      </div>

      <div class="form-group">
        <label for="username">Username</label>
        <input type="text" id="username" [(ngModel)]="username" name="username" placeholder="Inserisci username"
          required>
      </div>

      <div class="form-group">
        <label for="password">Password</label>
        <input type="password" id="password" [(ngModel)]="password" name="password" placeholder="Inserisci password"
          required>
      </div>

      <div class="error-message" *ngIf="error">
        {{ error }}
      </div>

      <button type="submit" [disabled]="loading" class="login-btn">
        {{ loading ? 'Attendere...' : (mode === 'register-company' ? 'Registra azienda' : 'Accedi') }}
      </button>
    </form>
  </div>
</div>
